<template>
  <div v-if="message" class="text-center">
    <div class="alert-block"
        :class="{
          'alert-block-warning': type === 'warning',
          'alert-block-success': type === 'success',
          'alert-block-error': type === 'error',
          'alert-block-info': type === 'info',
          'alert-block-full': type === 'full'
        }">
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: ['type', 'message']
}
</script>

<style scoped lang="scss">
.alert-block {
  border: solid;
  border-width: 0 0 2px 0;
  display: inline-block;
  margin: $gap-md auto;
  width: auto;

  p {
    font-weight: bold;
    margin: 0;
    padding: $gap-md $gap-lg;
  }

  &-success {
    border-color: $color-success;
  } // END .alert-block-success;
  &-warning {
    border-color: $color-warning;
  } // END .alert-block-warning;
  &-error {
    border-color: $color-error;
  } // END .alert-block-error;
  &-info {
    border-color: $color-info;
  } // END .alert-block-info;

  &-full {
    text-align: left;

    p {
      font-weight: normal;
      padding: $gap-md 0;
    }
  } // END .alert-block-full;

}
</style>
